import {
  getEmptyPopupRelations,
  PopupRelations,
  popupRelationsFromResponse,
  popupRelationsToUpsertRequest,
} from './PopupRelations';

export interface Popup {
  id: number;
  title: string;
  image: string;
  linkUrl: string;
  maxShowPerUser?: number;
  delaySeconds: number;
  showInHome: boolean;
  showInAllProducts: boolean;
  showInAllCategories: boolean;
  showInAllBrands: boolean;
  isActive: boolean;
  locale?: string;
  relations: PopupRelations;
  createdAt: Date;
  updatedAt: Date;
}

export const getEmptyPopup = (): Popup => ({
  id: 0,
  title: '',
  image: '',
  linkUrl: '',
  delaySeconds: 0,
  showInHome: false,
  showInAllProducts: false,
  showInAllCategories: false,
  showInAllBrands: false,
  isActive: true,
  relations: getEmptyPopupRelations(),
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const popupFromResponse = (responseData: any): Popup => ({
  id: responseData.id,
  title: responseData.title,
  image: responseData.image,
  linkUrl: responseData.link_url,
  maxShowPerUser: responseData.max_show_per_user,
  delaySeconds: responseData.delay_seconds,
  showInHome: responseData.show_in_home,
  showInAllProducts: responseData.show_in_all_products,
  showInAllCategories: responseData.show_in_all_categories,
  showInAllBrands: responseData.show_in_all_brands,
  isActive: responseData.is_active,
  locale: responseData.locale,
  relations: popupRelationsFromResponse(responseData.relations),
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});

export const popupToUpsertRequest = (popup: Popup) => ({
  title: popup.title,
  link_url: popup.linkUrl,
  max_show_per_user: popup.maxShowPerUser,
  delay_seconds: popup.delaySeconds,
  show_in_home: popup.showInHome,
  show_in_all_products: popup.showInAllProducts,
  show_in_all_categories: popup.showInAllCategories,
  show_in_all_brands: popup.showInAllBrands,
  is_active: popup.isActive,
  locale: popup.locale,
  relations: popupRelationsToUpsertRequest(popup.relations),
});
